const en = {
	storeManagement: 'Store Management',
	storeType: 'Store Type',
	applicationStatus: 'Application Status',
	storeStatus: 'Store Status',
	storeCode: 'Store Code',
	storeName: 'Store Name',
	group: 'Group',
	omniGroup: 'Group',

	addGroup: 'Go to Group',
	groupTip: 'Know more about Group Management',
	groupTipText: 'Grouping can be used to isolate permissions for your company\'s regions, businesses, etc., merge and analyze data from multiple websites/store, etc. If not needed, default management will be used.',
	storeAddress: 'Store Address',
	applicationTime: 'Application Time',
	withdrawAccount: 'Withdrawal Account',
	all: 'All',
	directStore: 'Direct Store',
	franchiseStore: 'Franchise Store',
	approved: 'Approved',
	decline: 'Decline',
	pending: 'Pending',
	modify: 'Modify',
	noStoreAdded: 'You have not added any stores yet',
	realNameAuthFirst: 'Please submit real-name verification first',
	submitRealNameAuthFirst: 'You need to submit real-name verification before adding a store',
	submitAuthMaterials: 'Submit Verification Materials',
	submitStoreInfo: 'Submit Store Information',
	storeDetails: 'Store Details',
	addStore: 'Add Store',
	fillLegalPerson: 'Please fill in legal person information',
	fillBeneficiary: 'Please fill in beneficiary information',
	fillDirector: 'Please fill in  company director information',

	basicInfo: 'Basic Information',
	storeInfo: 'Store Information',
	directStoreType: 'Direct Store',
	franchiseStoreType: 'Franchise Store',
	storeNameEn: 'Store Name (English Only)',
	storePhone: 'Store Contact Number',
	businessLicenseNo: 'Business License Number',
	licenseEffectiveDate: 'License Effective Date',
	licenseExpiryDate: 'License Expiry Date',
	hkBusinessLicenseNo: 'BusinessLicenceCertNo', // HK 修改
	hkBusinessRegistrationCertificate: 'Business Registration Certificate', // HK 新增
	hkLicenseEffectiveDate: 'Business Registration Ordinance Effect Date', // HK 修改
	hkLicenseExpiryDate: 'Business Registration Ordinance Expiration Date', // HK 修改
	hkRegistrationCertificate: 'Business Registration Ordinance', // HK 新增
	hkRegistrationCertificateNo: 'Certificate of Incorporation Number', // HK 新增
	hkCompanyEstablishedDate: 'Certificate of Incorporation Established Date', // HK 新增
	hkAnnualReport: 'NAR1/NNC', // HK 新增
	hkAnnualReportTips: 'Companies within one year: provide NNC1 (Incorporation Form). Over one year: provide NAR1 (Annual Return).', // HK 新增
	hkAddressProof: 'Proof of address', // 9231 HK新增
	hkBillOrcontract: 'Company office lease contract', // 9231 HK新增
	hkBankAccountInformation: 'Bank Account Information', // 9231 HK新增
	hkBankAccountInformationTips: 'Please provide a bank certificate valid for three months.', // 9231 HK新增
	hkCompanyEnName: 'Company Legal Name in English',
	companyRegisterCountry: 'Business Location',
	licenseImage: 'Business License Image',
	articlesOfAssociation: 'Articles of Association (Store)',
	country: 'Country',
	province: 'Province/State',
	city: 'City',
	district: 'District',
	addressEn: 'Detailed Address (English)',
	postcode: 'Postcode',
	relatedPersonnel: 'Related Personnel',
	fillStoreLegalPerson: 'Please fill in store legal person information',
	addLegalPerson: 'Add Legal Person',
	fillStoreDirectorPerson: 'Please fill in  company director information',
	addDirectorPerson: 'Add Company Director Information',
	fillStoreBeneficiary: 'Please fill in store beneficiary information',
	addBeneficiary: 'Add Beneficiary',
	otherMaterials: 'Other Materials',
	storePhotos: 'Store Photos',
	showStoreNumber: 'Store number must be visible',
	priceList: 'Price List',
	businessRegistrationCertificate: 'Business Registration Certificate',
	consumptionPriceList: 'Store Price List',
	warehousePhotos: 'Warehouse Photos',
	purchaseRecords: 'Purchase Records',
	settlementAccount: 'Settlement Account',
	settlementAccountType: 'Settlement Account Type',
	distributionAccount: 'Distribution Account',
	withdrawAccountNumber: 'Withdrawal Account Number',
	storeLegalPerson: 'Store Legal Person',
	storeBeneficiary: 'Store Beneficiary',
	directorPerson: 'Store Director',

	confirm: 'Confirm',
	cancel: 'Cancel',
	search: 'Search',
	reset: 'Reset',
	addStoreBtn: 'Add Store',
	operation: 'Operation',
	viewDetails: 'View Details',
	saveSuccess: 'Save Successful',
	required: 'The field is required.',
	enNameRule: 'Please enter English characters only',
	emailRule: 'Email address format is incorrect',
	account: {
		crzStoreType: 'Store Type',
		crzCategory: 'Main Business Category',
		crzUsage: 'Business Purpose',
		crzEmail: 'Store Email',
		partnershipDeedImage: 'Partnership Proof',
		shareStructureImage: 'Equity Structure',
		legal: 'Legal Representative',
		legal1: 'Store Operator',
		storeBeneficiary: 'Store Beneficiary (Equity ≥25%)',
		storePartner: 'Store Partner',
		storeAgent: 'Agent (Optional)',
		addPartner: 'Add Partner',
		addAgent: 'Add Agent',
		fillAgentPerson: 'Please Enter Agent Information',
		fillPartner: 'Please Enter Partner Information',
		success: 'Submission Successful',
		applyCrz: 'Apply for Distribution Account',
		pending: 'Under Review',
		notActive: '(Not Activated)',
		active: 'Activate Account',
		needLiveness: 'Under Review - Facial Recognition Required',
		liveness: 'Facial Recognition',
		sole: 'Sole Proprietorship',
		partner: 'Partnership',
		company: 'Joint-stock Company',
		tip: 'As per audit requirements, please complete facial recognition for the following personnel via the link',
		reload: 'Refresh Status',
		copy: 'Copy',
		copied: 'Copied to clipboard',
		copyfailed: 'Copy failed, please try again later',
		incomplete: 'Not Completed',
		failed: 'Failed',
		completed: 'Completed',
		submit: 'Submit Application',
		policy1: 'Your application information may be transferred overseas only for the opening and review of distribution accounts, PingPong will process and strictly keep your data confidential in accordance with the',
		policy2: '.'
	},
	phTaxCardNumber: 'BIR Certificate of Registration Number', // PH新增
	phTaxCardImg: 'BIR Certificate of Registration Number', // PH新增
	companyRegisterCertificate: 'Registration Document', // 公司注册证明
	generalInfoTable: 'General Information Sheet', // 公司基本信息表
	specialIndustryLicense: 'Special Industry Licenses', // 特殊行业许可证
	subMerchantInfoTable: 'Sub-merchant Information Form', // 子商户信息表
	bankAccountInformation: 'Bank Account Information', // PH 新增
	registeredCapitalCertificate: 'Registered Capital Certificate', // JP 新增
}

export default en
